import { z } from 'zod';
import { zObject } from '../util/zod';

export const officeProviderBaseUrlsSchema = z.object({
    imap_inbox_url: z.string(),
    dav_calendar_url: z.string(),
    dav_address_book_url: z.string(),
});

export type OfficeProviderBaseUrls = z.infer<typeof officeProviderBaseUrlsSchema>;

export const ImapConnection = {
    NONE: 'none',
    SSL: 'ssl',
    STARTTLS: 'starttls',
} as const;

export const officeUserConfigurationSchema = z.object({
    username: z.string(),
    hostname: z.string(),
    imapPort: z.number(),
    imapConnectionSecurity: z.nativeEnum(ImapConnection),
    imapMailbox: z.string(),
    calDavCalendar: z.string(),
    cardDavAddressBook: z.string(),
    provider: z.string().nullable(),
});

export type OfficeUserConfiguration = z.infer<typeof officeUserConfigurationSchema>;

export const officeSetConfigurationPayloadSchema = zObject({
    ...officeUserConfigurationSchema.shape,
    password: z.string(),
});

export type OfficeSetConfigurationPayload = z.infer<typeof officeSetConfigurationPayloadSchema>;

export const imapInboxMailSchema = z.object({
    date: z.string(),
    fromName: z.string(),
    subject: z.string(),
    body: z.string(),
    read: z.boolean(),
    attachmentsCount: z.number(),
    url: z.string().nullable(),
});
export type ImapInboxMail = z.infer<typeof imapInboxMailSchema>;

export const davCalendarEventSchema = z.object({
    summary: z.string(),
    start: z.string(),
    end: z.string(),
    status: z.string(),
    url: z.string().nullable(),
});

export type DavCalendarEvent = z.infer<typeof davCalendarEventSchema>;

export const davAddressBookContactSchema = z.object({
    fullName: z.string(),
    lastName: z.string(),
    firstName: z.string(),
    initial: z.string(),
    imageColor: z.string(),
    url: z.string().nullable(),
});

export type DavAddressBookContact = z.infer<typeof davAddressBookContactSchema>;

export const OfficeProviderSchema = z.object({
    id: z.string(),
    label: z.string(),
});

export type OfficeProvider = z.infer<typeof OfficeProviderSchema>;
